import { LeafletDirective } from './leaflet.directive';
import { Map } from 'leaflet';
var LeafletDirectiveWrapper = /** @class */ (function () {
    function LeafletDirectiveWrapper(leafletDirective) {
        this.leafletDirective = leafletDirective;
    }
    LeafletDirectiveWrapper.prototype.init = function () {
        // Nothing for now
    };
    LeafletDirectiveWrapper.prototype.getMap = function () {
        return this.leafletDirective.getMap();
    };
    return LeafletDirectiveWrapper;
}());
export { LeafletDirectiveWrapper };
//# sourceMappingURL=leaflet.directive.wrapper.js.map